import { Link } from "react-router-dom";
import { NAV } from "@/components/site/Header";

export const Footer = ({ content }) => {
  const f = content.footer;
  const email = content.settings.contact_email;
  return (
    <footer className="border-t border-[#B9A9D8]/40 bg-white" data-testid="site-footer">
      <div className="wrap grid gap-12 py-16 sm:py-20 md:grid-cols-[1.3fr_1fr]">
        <div>
          <img src="/logo.webp" alt="Violet Psychotherapy" width="200" height="100" loading="lazy" className="h-20 w-auto" />
          <p className="mt-8 font-display text-2xl leading-snug text-[#22304A]" data-testid="footer-credential">{f.credential}</p>
          <p className="mt-2 text-[#6B7280]">{f.tagline}</p>
        </div>
        <div className="grid grid-cols-2 gap-8">
          <nav aria-label="Footer">
            <p className="eyebrow mb-4">Explore</p>
            <ul className="space-y-3">
              {[{ to: "/", label: "Home" }, ...NAV, { to: "/privacy", label: "Privacy Policy" }].map((n) => (
                <li key={n.to}>
                  <Link to={n.to} className="text-[15px] text-[#22304A] transition-colors duration-300 hover:text-[#6F5B9E]" data-testid={`footer-nav-${n.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
                    {n.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>
          <div>
            <p className="eyebrow mb-4">Contact</p>
            <a href={`mailto:${email}`} className="text-link break-all text-[15px]" data-testid="footer-email-link">{email}</a>
            <p className="mt-3 text-[15px] text-[#6B7280]">Virtual sessions only · Ontario</p>
          </div>
        </div>
      </div>
      <div className="border-t border-[#B9A9D8]/30">
        <div className="wrap flex flex-col gap-2 py-6 text-sm text-[#6B7280] sm:flex-row sm:justify-between">
          <span data-testid="footer-copyright">{f.copyright}</span>
          <Link to="/admin" className="transition-colors duration-300 hover:text-[#6F5B9E]" data-testid="footer-admin-link">Admin</Link>
        </div>
      </div>
    </footer>
  );
};
